// extracted by mini-css-extract-plugin
export default {"appContainer":"Layout_appContainer__XTjTx","appContent":"Layout_appContent__UmxF5"};